'use client';

import {
  SlackChannel,
  getAdvertiserContactMessage,
} from '@baseball-near-you/common';
import {
  Button,
  Form,
  FormInput,
  FormPhoneNumberInput,
  FormTextarea,
  toast,
} from '@baseball-near-you/ui';
import { clients } from '@bb/lib/clients';
import { MailCheck } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
import { z } from 'zod';

export function AdvertContactForm(props: { onSuccess?: () => void }) {
  return (
    <Form
      onSubmit={async (data) => {
        const message = getAdvertiserContactMessage({
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phone: data.phone,
          message: data.message,
          url: undefined,
        });
        await clients.slack.postMessage({
          payload: {
            text: `New advertisement contact - ${data.email}`,
            channel: SlackChannel.AdContacts,
            ...message,
          },
        });
        props.onSuccess?.();

        toast('Message sent successfully!', {
          icon: <MailCheck />,
          description: 'We will get back to you soon.',
          className: 'space-x-1.5 !text-green-800',
          descriptionClassName: '!text-green-800',
          position: 'top-center',
        });
      }}
      schema={z.object({
        firstName: z.string().min(1, 'First name is required'),
        lastName: z.string().min(1, 'Last name is required'),
        email: z.string().email().min(1, 'Email is required.'),
        phone: z.string().min(1, 'Phone number is required.'),
        message: z.string().optional(),
      })}
      className="space-y-5"
    >
      <div className="flex flex-col justify-between space-y-5 sm:flex-row sm:space-x-5 sm:space-y-0">
        <FormInput name="firstName" label="First name" />
        <FormInput name="lastName" label="Last name" />
      </div>
      <FormInput name="email" label="Email" />
      <FormPhoneNumberInput name="phone" label="Phone number" />
      <FormTextarea name="message" label="Message" />
      <SendMessageButton />
    </Form>
  );
}

export function SendMessageButton() {
  const { formState } = useFormContext();
  return (
    <Button
      className="w-full bg-red"
      type="submit"
      loading={formState.isSubmitting}
    >
      Send Message
    </Button>
  );
}
